import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

const ALLOWED_COUNTRIES = ['fr', 'de', 'es', 'it', 'pt', 'nl', 'be'];

import { ZENDESK_DEFAULTS } from '@repo/shared-config/constants/zendesk';

export default class ZendeskLocalizationService extends Service {
  @service intl;

  @tracked _organizationCountry = ZENDESK_DEFAULTS.UNAUTH_FALLBACK_COUNTRY;

  get organizationCountry() {
    return this._organizationCountry.toLowerCase();
  }

  set organizationCountry(country) {
    this._organizationCountry = ALLOWED_COUNTRIES.includes(country?.toLowerCase())
      ? country?.toLowerCase()
      : ZENDESK_DEFAULTS.UNAUTH_FALLBACK_COUNTRY;
  }

  calcZendeskLocale(locale = ZENDESK_DEFAULTS.AUTH_FALLBACK_LOCALE) {
    let orgCountry = this.organizationCountry;
    let userLocale = locale.toLowerCase();
    let zendeskLocale = userLocale;

    if (orgCountry !== userLocale) {
      zendeskLocale = ZENDESK_DEFAULTS.AUTH_FALLBACK_LOCALE;
    }
    return zendeskLocale;
  }

  @tracked _userLocale = this.calcZendeskLocale(this.intl.primaryLocale);

  get userLocale() {
    return this._userLocale;
  }

  get localization() {
    let orgCountry = this.organizationCountry;
    let userLocale = this.userLocale;

    return {
      orgCountry,
      userLocale,
    };
  }
}
